import {
  Leaf,
  Droplets,
  TreePine,
  Waves,
  Trash2,
} from "lucide-react";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const COMPANY = {
  name: "Georgia Outdoor Worx",
  phone: "478.418.2629",
  phoneLink: "tel:+14784182629",
  email: "contactus@georgiaoutdoorworx.com",
  instagram: "@georgiaoutdoorworx",
  instagramLink: "https://instagram.com/georgiaoutdoorworx",
  area: "Serving All Middle Georgia",
};

export const SERVICES = [
  {
    id: "lawn-care",
    icon: Leaf,
    title: "Lawn Care",
    description: "Regular mowing, trimming, and edging to keep your lawn clean and well-maintained.",
    image: "https://images.unsplash.com/photo-1558904541-efa843a96f01?q=80&w=2070&auto=format&fit=crop"
  },
  {
    id: "landscape-maintenance",
    icon: TreePine,
    title: "Landscape Maintenance",
    description: "Plant pruning, shrub care, and seasonal cleanup to enhance your garden's appearance.",
    image: "https://customer-assets.emergentagent.com/job_landscape-portfolio-1/artifacts/k33r48aa_Landscape-Maintenance.png"
  },
  {
    id: "pine-straw-mulch",
    icon: Leaf,
    title: "Pine Straw & Mulch",
    description: "Application of pine straw and mulch to protect roots, suppress weeds, and enhance appearance.",
    image: "https://customer-assets.emergentagent.com/job_landscape-portfolio-1/artifacts/pfvaclqv_black-mulch.png"
  },
  {
    id: "drainage-solutions",
    icon: Droplets,
    title: "Drainage Solutions",
    description: "Planning and execution of systems to improve water flow, preventing accumulation and erosion.",
    image: "https://customer-assets.emergentagent.com/job_landscape-portfolio-1/artifacts/p7wcoea1_outdoor-drainage.avif"
  },
  {
    id: "pressure-wash",
    icon: Waves,
    title: "Pressure Wash",
    description: "Pressure washing of exterior surfaces to remove dirt, mold, and buildup, restoring a clean and refreshed appearance.",
    image: "https://customer-assets.emergentagent.com/job_landscape-portfolio-1/artifacts/svh922jf_pressure-cleaning-wash.jpg"
  },
  {
    id: "property-cleaning",
    icon: Trash2,
    title: "Property Cleaning",
    description: "Property cleaning services to remove debris, clutter, and unwanted materials, leaving outdoor spaces clean, organized, and well maintained.",
    image: "https://customer-assets.emergentagent.com/job_landscape-portfolio-1/artifacts/40b54ce4_Property-Cleaning.png"
  }
];

export const TEAM_MEMBERS = [
  {
    id: "team-1",
    name: "Felipe Lima",
    role: "Entrepreneur & Co-founder",
    image: "https://customer-assets.emergentagent.com/job_landscape-portfolio-1/artifacts/6fbwq1ug_felipe-lima-georgia-outdoor-worx%20-2.jpeg",
    instagram: "https://instagram.com/georgiaoutdoorworx"
  },
  {
    id: "team-2",
    name: "Hugo Sousa Santos",
    role: "Civil Engineer & Co-founder",
    image: "https://customer-assets.emergentagent.com/job_landscape-portfolio-1/artifacts/5ebph55z_hugo-sousa-santos.jpeg",
    instagram: "https://instagram.com/hsantosconstruction"
  },
  {
    id: "team-3",
    name: "Edward Groisman",
    role: "Systems Analyst & Investor",
    image: "https://customer-assets.emergentagent.com/job_landscape-portfolio-1/artifacts/edt2yqqu_Eddi-Groisman-georgia-outdoor-worx.jpeg",
    instagram: "https://instagram.com/georgiaoutdoorworx"
  },
  {
    id: "team-4",
    name: "Rustin Hardesty",
    role: "Chief Manager",
    image: "https://customer-assets.emergentagent.com/job_fe0c799b-8592-47d0-aa03-f70fc060f969/artifacts/4s14ikwy_IMG_3676.jpg",
    instagram: "https://instagram.com/georgiaoutdoorworx"
  }
];

export const PROPERTY_OPTIONS = [
  { key: "up_to_1_acre", label: "Up to 1 Acre" },
  { key: "1_to_2_acres", label: "1 to 2 Acres" },
  { key: "2_to_3_acres", label: "2 to 3 Acres" },
  { key: "3_to_4_acres", label: "3 to 4 Acres" },
  { key: "above_5_acres", label: "5+ Acres" },
];

export const SHRUB_OPTIONS = [
  { key: "none", label: "None" },
  { key: "front_only", label: "Front Only" },
  { key: "front_1_side", label: "Front + 1 Side" },
  { key: "front_2_sides", label: "Front + 2 Sides" },
  { key: "whole_house", label: "Whole House" },
];
